import { GetUserResponse } from '@/server/client/v2-operating-client'
import { NextFunction, Request, Response } from 'express'
import Role from '@/enums/Role'

export const hasRole = ({
  role,
  operator,
}: {
  role: Role
  operator: GetUserResponse
}) => {
  return operator.areas.filter(area => area.role === role).length > 0
}

export const isLoggedIn = (req: Request, res: Response, next: NextFunction) => {
  if (!req.user) {
    return res.status(401).json({
      message: '로그인 부탁드립니다.',
    })
  }

  next()
}

export const isInsuranceRole = (req: Request, res: Response, next: NextFunction) => {
  const operator = req.user as GetUserResponse

  if (!hasRole({ role: Role.INSURANCE, operator })) {
    return res.status(403).json({
      message: '접근할 수 없습니다.',
    })
  }

  next()
}

export const isNotInsurance = (req: Request, res: Response, next: NextFunction) => {
  const operator = req.user as GetUserResponse

  if (hasRole({ role: Role.INSURANCE, operator })) {
    return res.status(403).json({
      message: '접근할 수 없습니다.',
    })
  }

  next()
}
